module.exports = __webpack_public_path__ + "static/media/cal_poly_slo_logo.d12fb777.jpg";